export default __webpack_public_path__ + "static/media/bnbIcon.42e41474.png";